import type { Project } from "../api/client";

export interface StudyDeliverable {
  key: string;
  kind: string;
  title: string;
  status: string;
  version: string;
  next: string;
  nextLabel: string;
  badge: string;
  badgeKind: string;
  touched: string;
  spark: number[];
  warning?: boolean;
  cite?: boolean;
}

export interface StudyProfile {
  site: string;
  phase: string;
  question: string;
}

export interface FieldNote {
  title: string;
  body: string;
  next: string;
}

export const STUDY_DELIVERABLES: StudyDeliverable[] = [];
export const TODAY_ACTIVITY: Array<{ time: string; title: string; sub: string; kind: string; meta: string }> = [];
export const OPEN_QUESTIONS: Array<{ text: string; source: string; resolved: boolean }> = [];
export const HOT_SOURCES: Array<{ n: number; title: string; sub: string; uses: string }> = [];
export const FIELD_NOTE: FieldNote | null = null;

export function profileForStudy(study: Project | null): StudyProfile {
  if (!study) {
    return {
      site: "",
      phase: "No study selected",
      question: "No research question saved for this study.",
    };
  }

  return {
    site: study.archived ? "Archived" : "Active",
    phase: `${study.counts.total} item${study.counts.total === 1 ? "" : "s"}`,
    question: "No research question saved for this study.",
  };
}

export function studyInitials(name: string): string {
  const letters = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
  return letters || "S";
}

export function estimatedStudySpend(study: Project, totalUsd = 0): number {
  if (totalUsd <= 0) return 0;
  return Math.max(1, study.counts.total);
}
